import { Button } from '../Button/Button';

export interface ErrorStateProps {
  title: string;
  body: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function ErrorState({ title, body, action }: ErrorStateProps) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4">
      <h2 className="text-x-large font-bold">{title}</h2>
      <p className="text-medium text-neutral-primary">{body}</p>
      {action && (
        <Button
          variant="filled"
          size="medium"
          colorScheme="secondary"
          onClick={action.onClick}
          className="min-w-[360px] mt-4"
        >
          {action.label}
        </Button>
      )}
    </div>
  );
}
